import React from 'react';
import { Tooltip } from '@mui/material';
import '../ClassificationBadge/ClassificationBadge.css';

const GlobeIcon = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const WebSearchBadge: React.FC = () => (
    <Tooltip title="This answer used web search" placement="top">
        <div className="classification-badge badge-web-search">
            <GlobeIcon />
        </div>
    </Tooltip>
);
